/**
 * Shared backend origin for all VIPSo frontends (web + native + admin).
 * Not derived from the tenant host — always `VITE_API_URL` at build time.
 *
 * `graphql-request` requires an absolute URL (`new URL(...)`); an empty
 * base produces `/api/graphql` and throws "Failed to construct 'URL'".
 */
export function resolveApiOrigin(): string {
  const env =
    typeof import.meta !== 'undefined'
      ? (import.meta as ImportMeta & { env?: Record<string, string> }).env
      : undefined;
  const configured = String(env?.VITE_API_URL || '')
    .trim()
    .replace(/\/$/, '');

  if (configured && /^https?:\/\//i.test(configured)) {
    return configured;
  }

  return '';
}

/** Absolute GraphQL endpoint on the shared backend. */
export function resolveGraphqlUrl(): string {
  const origin = resolveApiOrigin();
  if (!origin) {
    throw new Error(
      'VITE_API_URL is not set. Set the shared backend URL at build time (the app\'s .env.production or Railway Variables).',
    );
  }
  return `${origin}/api/graphql`;
}
